import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useTranslation } from 'react-i18next'

gsap.registerPlugin(ScrollTrigger)

const counters = [
  { value: 500, suffix: '+', label: 'counter.years', icon: '🏛' },
  { value: 10000, suffix: '+', label: 'counter.devotees', icon: '🙏' },
  { value: 24, suffix: '', label: 'counter.festivals', icon: '🎊' },
  { value: 365, suffix: '', label: 'counter.service', icon: '🪔' },
]

export default function CounterSection() {
  const { t } = useTranslation()
  const ref = useRef(null)

  useGSAP(() => {
    const nums = ref.current.querySelectorAll('.counter-num')
    nums.forEach((el, i) => {
      const target = counters[i].value
      const obj = { val: 0 }
      ScrollTrigger.create({
        trigger: ref.current,
        start: 'top 80%',
        once: true,
        onEnter() {
          gsap.to(obj, {
            val: target,
            duration: 2,
            ease: 'power1.out',
            onUpdate() {
              el.textContent = Math.round(obj.val).toLocaleString() + counters[i].suffix
            },
          })
        },
      })
    })
  }, { scope: ref })

  return (
    <section ref={ref} className="bg-saffron py-16">
      <div className="max-w-5xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {counters.map((c) => (
          <div key={c.label} className="flex flex-col items-center gap-2">
            <span className="text-3xl">{c.icon}</span>
            <span className="counter-num font-display text-4xl md:text-5xl font-bold text-white">
              0{c.suffix}
            </span>
            <span className="text-white/80 text-sm font-medium">{t(c.label)}</span>
          </div>
        ))}
      </div>
    </section>
  )
}
